import FaqBlockArrow from './FaqBlockArrow'

export default FaqBlockArrow
